

export default {
    data() {
        return {
            closeBtnShowStatus: true, // closeBtn要不要顯示的參數
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        /**
             * @description 獲取此訂單內容-api
             */
        async onlyFetchSingleOrder(orderId, cb) {
            try {
                let newDrawerOrderData = await this.$store.dispatch('order/fetchSingle', orderId)
                newDrawerOrderData = this.initHelpers(Object.assign({}, newDrawerOrderData))
                this.drawerOrderData = this.initSpaceHelpers(Object.assign({}, newDrawerOrderData))
                await cb()
            } catch (error) {
                console.error(error.message)
            }
        },

        /**
         * @description 將close Btn 隱藏
         */
        closeBtnShowFunc(status) {
            this.closeBtnShowStatus = status
        }
    }
}
